<div class="container-margin">
  <form [formGroup]="bulkShareForm">
    <h2>{{ translationService.getUploadAndValidateFilesText() }}</h2>

    <div class="form-groups">
      <p>
        {{
          translationService.getProductShareCsvTemplateSelectionMessageText()
        }}
      </p>

      <div class="form-group template-name-field">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getCsvTemplateNameText()
          }}</mat-label>
          <mat-select formControlName="template">
            @for (template of templates; track template.id) {
              <mat-option [value]="template.id">{{
                template.templateName
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <p>{{ translationService.getProductShareCsvFileMessageText() }}</p>

      <div class="form-group">
        <mat-label>{{
          translationService.getProductShareCsvFileText()
        }}</mat-label>
        <input
          type="file"
          (change)="onFileChange($event)"
          #shareCsvFile
          accept=".csv"
        />
      </div>
    </div>
  </form>

  <div class="actions margin-top-10">
    <button
      mat-stroked-button
      extended
      color="primary"
      class="action-item"
      type="button"
      (click)="reset()"
    >
      <mat-icon>refresh</mat-icon>
      {{ translationService.getResetText() }}
    </button>

    <button
      mat-raised-button
      extended
      color="primary"
      class="action-item"
      type="button"
      (click)="onSubmit()"
      [disabled]="bulkShareForm.invalid || !hasSelectedFile"
    >
      <mat-icon>check</mat-icon>
      {{ translationService.getValidateText() }}
    </button>
  </div>

  <app-review-shared-products
    [rows]="reviewResponse.rows"
    (confirmed)="createShares()"
  ></app-review-shared-products>
</div>
